import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  text: '"Llevaba años sintiéndome \'inflada\' todo el tiempo. Con las recetas de 15 minutos, por fin pude llevar mi dieta al colegio donde trabajo y en la primera semana recuperé mi energía."',
  name: 'Marta J.',
  role: 'Docente, 52 años',
  city: 'México'
}, {
  text: '"Lo que más amé fue la guía de sustitutos. Aquí en Colombia la harina de almendras es cara, pero con los consejos de este manual gasto lo mismo que antes y como mil veces mejor."',
  name: 'Carmen R.',
  role: '45 años',
  city: 'Colombia'
}, {
  text: '"Pensé que por tener Hashimoto estaba condenada a vivir cansada. El Acelerador de 21 Días me salvó la vida porque no tengo que pensar qué cocinar. Simplemente sigo el plan y me siento increíble."',
  name: 'Lucía P.',
  role: 'Enfermera, 48 años',
  city: 'Chile'
}, {
  text: '"La neblina mental era lo peor para mí. Olvidaba las cosas en el trabajo. Desde que empecé con los elixires mañaneros, mi mente está clara y hasta mi piel se ve más luminosa."',
  name: 'Elena G.',
  role: 'Contadora, 55 años',
  city: 'Argentina'
}, {
  text: '"Había probado todas las dietas y siempre rebotaba. Este no es un libro de dietas, es un manual para entender tu cuerpo. Por fin la báscula empezó a bajar sin pasar hambre."',
  name: 'Rosa M.',
  role: 'Ama de casa, 60 años',
  city: 'Perú'
}];
export function Testimonials() {
  return <section className="py-8 px-4 bg-white" data-id="element-169">
      <div className="max-w-2xl mx-auto" data-id="element-170">
        <div className="text-center mb-6" data-id="element-171">
          <h2 className="text-xl sm:text-2xl font-heading font-bold text-brand-forest mb-2" data-id="element-172">
            💬 Voces de nuestra comunidad de guerreras
          </h2>
        </div>

        <div className="space-y-4" data-id="element-173">
          {testimonials.map((t, i) => <div key={i} className="bg-brand-cream border border-brand-border p-5 rounded-lg" data-id="element-174">
              <div className="flex items-center gap-1 mb-3 text-brand-orange" data-id="element-175">
                {[...Array(5)].map((_, idx) => <StarIcon key={idx} className="w-4 h-4 fill-current" data-id="element-176" />)}
              </div>
              <p className="text-brand-text italic text-sm sm:text-base mb-3" data-id="element-177">
                {t.text}
              </p>
              <div className="border-t border-brand-border pt-3" data-id="element-178">
                <div className="text-sm font-bold text-brand-forest" data-id="element-179">
                  {t.name}
                </div>
                <div className="text-xs text-brand-muted" data-id="element-180">
                  {t.role} • {t.city}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}